import { types } from "../types/types";

export const municipiosReducer = (state = {}, action) => {
    switch (action.type) {
        case types.municipios:
            return {
                data: action.payload,
            }
        default:
            return state;
    }
}

